var map = {
	"./cn/来华/pc.svg": "/WSS",
	"./en/来华/pc.svg": "oy0g"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e+9R";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/来华\/pc\.svg$
// module id = e+9R
// module chunks = 16